// Runtime configuration. window.config is populated from index.html, where the
// Pūrs hub substitutes {{PUBLIC_URL}} / {{BACKEND_URL}} / {{APP_VERSION}} /
// {{ENVIRONMENT}}. When a placeholder is left un-substituted (local dev, or a
// missing value) we fall back to a sane default.
const raw = window.config || {};

function resolve(value, fallback) {
  if (typeof value !== 'string') return fallback;
  // A value still wrapped in {{ }} means the hub did not substitute it.
  if (value.startsWith('{{') && value.endsWith('}}')) return fallback;
  return value;
}

export const APP_CONFIG = {
  publicUrl: resolve(raw.publicUrl, '/'),
  // The API base, e.g. "/api/". Upload endpoints live under <backendUrl>v1/...
  backendUrl: resolve(raw.backendUrl, '/api/'),
  version: resolve(raw.version, 'dev'),
  environment: resolve(raw.environment, 'local'),
  defaultLocale: 'en',
  fallbackLocale: 'en',
  supportedLocales: ['lv', 'en'],
};

// Header carrying the upload-link token for anonymous contributors.
export const UPLOAD_TOKEN_HEADER = 'X-Upload-Token';

// Accepted image MIME types (HEIC / JPEG / PNG only).
export const ALLOWED_CONTENT_TYPES = [
  'image/jpeg',
  'image/png',
  'image/heic',
  'image/heif',
];

// Extension fallback for browsers that report an empty type for HEIC files.
export const ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'heic', 'heif'];

export const LOCALE_STORAGE_KEY = 'purs-upload-locale';
